import React from "react"
import PropTypes from "prop-types"

import { useForm } from "@components/Form"
import { UpdateModal } from "@components/Page"
import { MODAL_WIDTH2 } from "@components"
import { connectAccountIdentityOperation as updateOperation } from "@api/services/investments"

import getInputs from "./helpers/getInputs"
import { AccountShape } from "../../shapes"

const LABEL_TITLE = "Create User"
const LABEL_ENTITY = "User"


const CreateIdentityModal = ({
  modal,
  account,
  readAccount
}) => {
  const form = useForm()

  const inputs = getInputs(account)
  const schema = updateOperation.getSchema(inputs)

  const onSubmit = parameters => {
    parameters.id = account.id
    return parameters
  }

  const onSuccess = () =>
    readAccount(account.id)

  const updateModalProps = {
    title: LABEL_TITLE,
    width: MODAL_WIDTH2,
    entity: LABEL_ENTITY,
    operation: updateOperation,
    submitLabel: LABEL_TITLE,
    form,
    modal,
    schema,
    onSubmit,
    onSuccess,
  }

  return (
    <UpdateModal {...updateModalProps} />
  )
}

CreateIdentityModal.propTypes = {
  modal: PropTypes.shape().isRequired,
  account: AccountShape.isRequired,
  readAccount: PropTypes.func.isRequired,
}

export default CreateIdentityModal
